import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Check, Circle } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export default function ProjectDetail() {
  const { id } = useParams();
  const { t, lang, sl } = useI18n();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/projects/${id}`).then((r) => setP(r.data)).catch(() => setP(false)); }, [id]);
  if (p === null) return <div className="text-muted-foreground">{t("common.loading")}</div>;
  if (p === false) return <div>Not found</div>;
  return (
    <div className="space-y-6 max-w-3xl">
      <Link to="/portal/projects" className="inline-flex items-center gap-2 text-sm link-muted"><ArrowLeft size={16} /> {t("portal.projects")}</Link>
      <div className="surface p-8">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <h1 className="font-display text-2xl font-black">{p.name}</h1>
          <span className="rounded-full bg-primary/15 text-primary px-3 py-1 text-sm font-semibold capitalize">{sl(p.status)}</span>
        </div>
        <p className="text-muted-foreground mt-3">{p.description}</p>
        <div className="mt-6">
          <div className="flex justify-between text-sm mb-1"><span>{t("portal.progress")}</span><span>{p.progress}%</span></div>
          <div className="h-3 rounded-full bg-secondary overflow-hidden"><div className="h-full bg-primary transition-all" style={{ width: `${p.progress}%` }} /></div>
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-6">
        <div className="surface p-6">
          <h3 className="font-display font-bold mb-4">{lang === "de" ? "Aufgaben" : "Tasks"}</h3>
          <div className="space-y-2">
            {(p.tasks || []).map((tk) => (
              <div key={tk.id} className="flex items-center gap-2.5 text-sm">
                {tk.done ? <Check size={16} className="text-primary" /> : <Circle size={16} className="text-muted-foreground" />}
                <span className={tk.done ? "line-through text-muted-foreground" : ""}>{tk.title}</span>
              </div>
            ))}
            {(!p.tasks || p.tasks.length === 0) && <p className="text-sm text-muted-foreground">{t("common.none")}</p>}
          </div>
        </div>
        <div className="surface p-6">
          <h3 className="font-display font-bold mb-4">{lang === "de" ? "Meilensteine" : "Milestones"}</h3>
          <div className="space-y-2">
            {(p.milestones || []).map((m) => (
              <div key={m.id} className="flex items-center gap-2.5 text-sm">
                {m.done ? <Check size={16} className="text-primary" /> : <Circle size={16} className="text-muted-foreground" />}
                <span className={m.done ? "line-through text-muted-foreground" : ""}>{m.title}</span>
              </div>
            ))}
            {(!p.milestones || p.milestones.length === 0) && <p className="text-sm text-muted-foreground">{t("common.none")}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
